import { Redirect, useLocation, useParams } from 'react-router-dom';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_LANGUAGES } from '@hypercharge/bbs-website-commons/lib/constants';

export const LanguageGuard: FC = () => {
  const {
    i18n: { language }
  } = useTranslation();
  const { lang } = useParams<{ lang?: string }>();
  const { pathname, search, hash } = useLocation();

  if (!lang) {
    if (!pathname.startsWith(`/${language}`)) {
      return <Redirect to={`/${language}${pathname}${search}${hash}`} />;
    } else {
      const splitPathname = pathname.split('/');
      const potentialLang = splitPathname[1];

      if (potentialLang.includes('-')) {
        splitPathname.splice(1, 1, language);
      } else {
        splitPathname.splice(1, 0, language);
      }

      const joinedPathname = splitPathname.join('/');

      return <Redirect to={`${joinedPathname}${search}${hash}`} />;
    }
  } else {
    const isSupportedLang = AVAILABLE_LANGUAGES.includes(lang);

    if (!isSupportedLang) {
      const replacedPathname = pathname.replace(`/${lang}`, `/${language}`);

      return <Redirect to={`${replacedPathname}${search}`} />;
    }
  }

  return null;
};
